import { render, staticRenderFns } from "./BattlesOverview.vue?vue&type=template&id=d7f94bb6&scoped=true"
import script from "./BattlesOverview.vue?vue&type=script&lang=js"
export * from "./BattlesOverview.vue?vue&type=script&lang=js"
import style0 from "./BattlesOverview.vue?vue&type=style&index=0&id=d7f94bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f94bb6",
  null
  
)

export default component.exports